import React from 'react';

import { Button, Icon } from '@iwoca/orion';
import { FormattedMessage, injectIntl } from 'react-intl';

import messages from './SpecifyOtherAnswer.messages';
import styles from './SpecifyOtherAnswer.module.css';
import OldButton from '../../../../components/Button';
import PureInput from '../../../../components/PureInput';

class SpecifyOtherAnswer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            answer: ''
        };
    }

    render() {
        const { answerExitPoll, hideOtherAnswer, intl } = this.props;
        const { answer } = this.state;

        return (
            <div>
                <div className={styles.specifyOtherHeaderQuestion}>
                    <FormattedMessage {...messages.specifyOtherQuestion} />
                </div>

                <form
                    autoComplete="off"
                    onSubmit={() => {
                        answerExitPoll({ details: answer });
                    }}>
                    <PureInput
                        type="text"
                        name="specify-other-exit-poll-answer"
                        value={answer}
                        placeholder={intl.formatMessage(
                            messages.specifyOtherAnswerPlaceholder
                        )}
                        handleChange={(e) => {
                            this.setState({
                                answer: e.target.value
                            });
                        }}
                        maxLength="50"
                        onBlur={(answer) => {
                            this.setState({ answer });
                        }}
                    />

                    <div className={styles.specifyOtherAnswerButtons}>
                        <Button
                            variant="tertiary"
                            onClick={() => hideOtherAnswer()}>
                            <Icon icon="angleLeft" />
                            <FormattedMessage {...messages.specifyOtherBack} />
                        </Button>

                        <OldButton type="submit">
                            <FormattedMessage {...messages.submitExitPoll} />
                        </OldButton>
                    </div>
                </form>
            </div>
        );
    }
}

export default injectIntl(SpecifyOtherAnswer);
